/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/

import type { AxiosInstance } from 'axios';

import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';

import type { CommonAPIResponse } from 'hems';

import type { CommonListQueryParamNew } from 'hems/common/dataGrid';
import type { ListResponseNew } from 'hems/common/types';
import type { ControlRequestBody, RemoteControlRequestsResponse } from 'hems/control';

export default class RemoteControlServiceAdmin extends Service {
  constructor(axios: AxiosInstance) {
    super(axios);
  }

  /** 제어 요청 */
  postControl = (deviceId: string, requestBody: ControlRequestBody): Promise<CommonAPIResponse> =>
    this.post<CommonAPIResponse>(apiWrapper.managerApiV1(`/devices/${deviceId}/control`), requestBody);

  /** 제어 요청 목록 조회 */
  getControlRequestsList = async (
    deviceId: string,
    param: CommonListQueryParamNew
  ): Promise<ListResponseNew<RemoteControlRequestsResponse>> => {
    return await this.get<ListResponseNew<RemoteControlRequestsResponse>>(
      apiWrapper.managerApiV1(`/devices/${deviceId}/control-requests`),
      param
    );
  };
}
